import { memo } from "react";
import { StagesPanel } from "../StagesPanel";
import { StageResponse } from "../../services/ProposalGenerationServices";

interface StagesTabProps {
  stages: StageResponse[];
  currentDialogueId: number;
  onStageClick: (dialogueId: number) => void;
  onClearStage?: (dialogueId: number) => void;
  onRemoveStage?: (dialogueId: number) => void;
  onAddStage?: (reportType: string) => void;
  isMutating?: boolean;
}

const StagesTab = memo(
  ({
    stages,
    currentDialogueId,
    onStageClick,
    onClearStage,
    onRemoveStage,
    onAddStage,
    isMutating,
  }: StagesTabProps) => {
    return (
      <StagesPanel
        stages={stages}
        currentDialogueId={currentDialogueId}
        onStageClick={onStageClick}
        onClearStage={onClearStage}
        onRemoveStage={onRemoveStage}
        onAddStage={onAddStage}
        isMutating={isMutating}
      />
    );
  },
);

StagesTab.displayName = "StagesTab";

export default StagesTab;
